import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import { FC } from 'react'
import IceberImage from '../../../media/if.png'

interface Props {
  mobileOpen: boolean
  handleDrawerToggle: () => void
}

const MobileAppBar: FC<Props> = ({ mobileOpen, handleDrawerToggle }) => {
  const appBarSx = {
    background: 'black',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media (max-width: 600px)': {
      width: '100%',
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      zIndex: '1300',
    },
  }

  const logoBoxSx = {
    maxWidth: '25%',
  }

  return (
    <AppBar position="static" sx={appBarSx}>
      <Toolbar>
        <Box component="img" src={IceberImage} alt="ICEBERG FINANCE" sx={logoBoxSx} />
      </Toolbar>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label={mobileOpen ? 'Close drawer' : 'Open drawer'}
          onClick={handleDrawerToggle}
          sx={{ ml: 'auto' }}
        >
          {mobileOpen ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

export default MobileAppBar
